import { FC } from 'react';
import DesktopTable from './Desktop';
import useMobile from 'hooks/useMobile';
import MobileTable from './Mobile';
import { MobileTableProps } from './Mobile/MobileTable';
import { DesktopTableProps } from './Desktop/DesktopTable';

const Table: FC<MobileTableProps | DesktopTableProps> = (props) => {
  const { isMobile } = useMobile();

  const isMobileProps = (
    props: MobileTableProps | DesktopTableProps,
  ): props is MobileTableProps => {
    return 'mobileMainContent' in props || 'mobileBottomColumn' in props;
  };

  const shouldRenderMobile = isMobile && isMobileProps(props);

  if (shouldRenderMobile) {
    return <MobileTable {...props} />;
  }

  return <DesktopTable {...props} />;
};

export default Table;
